// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.S9jd6yKr5YApczlauqE2 {
  display: block;
}

.aRQ4cjiMsTDOnpUxnykS {
  padding-bottom: 1rem;
}

.PFvwGRQEtV03TlStFSUh {
  font-size: 1rem;
  font-weight: 600;
  margin: 1rem 0;
}

.VIGA9WOWK8Y7iDXUjgTd {
  display: block;
}

.l94ml0SmuQ2SbRaH2cSA {
  margin-top: 1.5rem;
}

.l94ml0SmuQ2SbRaH2cSA,
.diqDt8Vq2dxS74zuEHmZ {
  margin-top: 1.5rem;
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .PFvwGRQEtV03TlStFSUh {
    display: none;
  }

  .aRQ4cjiMsTDOnpUxnykS {
    padding: 0;
  }

  .S9jd6yKr5YApczlauqE2 {
    padding: 0;
  }

  .l94ml0SmuQ2SbRaH2cSA,
  .diqDt8Vq2dxS74zuEHmZ {
    margin-top: 1rem;
  }

  .diqDt8Vq2dxS74zuEHmZ {
    width: 100%;
  }

  .c5guBrVsAhKWUQHoJi0D {
    height: 6rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .PFvwGRQEtV03TlStFSUh {
    display: none;
  }

  .aRQ4cjiMsTDOnpUxnykS {
    padding: 0;
  }

  .S9jd6yKr5YApczlauqE2 {
    padding: 0;
  }

  .l94ml0SmuQ2SbRaH2cSA,
  .diqDt8Vq2dxS74zuEHmZ {
    margin-top: 1rem;
  }

  .diqDt8Vq2dxS74zuEHmZ {
    width: 100%;
  }

  .c5guBrVsAhKWUQHoJi0D {
    height: 6rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BusinessOfferForm/BusinessOfferForm.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAgB;AAClB;;AAEA;;EAEE,kBAAgB;AAClB;;AAEA;;;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".businessOfferBlock {\n  display: block;\n}\n\n.title {\n  padding-bottom: 16px;\n}\n\n.subTitle {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 16px 0;\n}\n\n.businessOfferForm {\n  display: block;\n}\n\n.inputLabel {\n  margin-top: 24px;\n}\n\n.inputLabel,\n.submitButton {\n  margin-top: 24px;\n}\n\n@media (--tablet) {\n  .subTitle {\n    display: none;\n  }\n\n  .title {\n    padding: 0;\n  }\n\n  .businessOfferBlock {\n    padding: 0;\n  }\n\n  .inputLabel,\n  .submitButton {\n    margin-top: 16px;\n  }\n\n  .submitButton {\n    width: 100%;\n  }\n\n  .textarea {\n    height: 96px;\n  }\n}\n\n@media (--mobile) {\n  .subTitle {\n    display: none;\n  }\n\n  .title {\n    padding: 0;\n  }\n\n  .businessOfferBlock {\n    padding: 0;\n  }\n\n  .inputLabel,\n  .submitButton {\n    margin-top: 16px;\n  }\n\n  .submitButton {\n    width: 100%;\n  }\n\n  .textarea {\n    height: 96px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"businessOfferBlock": `S9jd6yKr5YApczlauqE2`,
	"title": `aRQ4cjiMsTDOnpUxnykS`,
	"subTitle": `PFvwGRQEtV03TlStFSUh`,
	"businessOfferForm": `VIGA9WOWK8Y7iDXUjgTd`,
	"inputLabel": `l94ml0SmuQ2SbRaH2cSA`,
	"submitButton": `diqDt8Vq2dxS74zuEHmZ`,
	"textarea": `c5guBrVsAhKWUQHoJi0D`
};
export default ___CSS_LOADER_EXPORT___;
